import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Modules() {
  const modules = [{
    num: '1',
    title: 'Entendiendo la Celiaquía',
    desc: 'Aprendé cómo cuidar correctamente tu salud.',
    items: ['Qué es la celiaquía.', 'Alimentos prohibidos.', 'Contaminación cruzada.', 'Cómo leer etiquetas.']
  }, {
    num: '2',
    title: 'Organización de Comidas Sin Gluten',
    desc: 'Dejá de improvisar tu alimentación.',
    items: ['Planificación semanal.', 'Horarios recomendados.', 'Cómo organizar compras.', 'Comidas rápidas y saludables.']
  }, {
    num: '3',
    title: 'Recetas Saludables para Todos los Días',
    desc: 'Opciones fáciles, nutritivas y deliciosas.',
    items: ['Desayunos.', 'Almuerzos.', 'Cenas.', 'Snacks y colaciones.']
  }, {
    num: '4',
    title: 'Alimentación Según Cada Edad',
    desc: 'Consejos específicos para cada etapa de vida.',
    items: ['Niños.', 'Adolescentes.', 'Adultos.', 'Adultos mayores.']
  }, {
    num: '5',
    title: 'Hábitos Saludables y Bienestar',
    desc: 'Cómo mejorar tu calidad de vida diaria.',
    items: ['Hidratación.', 'Ejercicio recomendado.', 'Descanso.', 'Alimentación consciente.']
  }, {
    num: '6',
    title: 'Vida Saludable Sin Gluten',
    desc: 'Aprendé a mantener hábitos saludables a largo plazo.',
    items: ['Organización personal.', 'Alimentación equilibrada.', 'Prevención de síntomas.', 'Bienestar físico y emocional.']
  }];
  return <section className="py-20 px-4 bg-warm-white" data-id="element-91">
      <div className="max-w-6xl mx-auto" data-id="element-92">
        <div className="text-center mb-16" data-id="element-93">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-94">
            Contenido Completo
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-forest" data-id="element-95">
            LOS 6 MÓDULOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-96">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="bg-cream p-8 md:p-10 rounded-3xl shadow-warm border border-sage/10 relative overflow-hidden group" data-id="element-97">
              <div className="absolute -top-6 -right-6 text-9xl font-serif text-sage/5 select-none group-hover:scale-110 transition-transform duration-500" data-id="element-98">
                {mod.num}
              </div>

              <div className="relative z-10" data-id="element-99">
                <span className="inline-block px-3 py-1 bg-sage/10 text-sage font-bold text-sm rounded-full mb-4" data-id="element-100">
                  MÓDULO {mod.num}
                </span>
                <h3 className="font-serif text-2xl md:text-3xl text-forest mb-2" data-id="element-101">
                  {mod.title}
                </h3>
                <p className="text-muted mb-8" data-id="element-102">{mod.desc}</p>

                <ul className="space-y-4" data-id="element-103">
                  {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-104">
                      <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-105" />
                      <span className="text-charcoal" data-id="element-106">{item}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}